import { routes } from "@/lib/routes";
import { isUUID } from "@/lib/validators/uuid";
import { pagePathOf } from "@/lib/chat/page-context-prompt";
import type { QuickAction } from "@/lib/chat/types";

/** Presentation context only. A URL never establishes campaign membership or ownership. */
export function isSellerRefreshPage(url?: string): boolean {
  const pathname = url ? pagePathOf(url) : null;
  if (!pathname) return false;
  const prefix = routes.campaigns.sellerRefresh("");
  return pathname.startsWith(prefix) && isUUID(pathname.slice(prefix.length));
}

export const SELLER_REFRESH_CHAT_GREETING =
  "Bei welcher Angabe brauchen Sie Hilfe? Beschreiben Sie kurz, was unklar ist.";

export const SELLER_REFRESH_CHAT_ACTIONS: QuickAction[] = [
  {
    key: "campaign_axes",
    label: "Frage zu einem Feld",
    message: "Ich brauche Hilfe bei einer Angabe in meinem bestehenden Angebot.",
  },
  {
    key: "campaign_missing_information",
    label: "Angaben fehlen mir",
    message:
      "Mir fehlen Angaben zu meinem bestehenden Angebot. Wie kann ich bei der Aktualisierung weiterkommen?",
  },
  {
    key: "campaign_callback",
    label: "Rückruf wünschen",
    message:
      "Ich möchte einen Rückruf, weil ich Hilfe beim Aktualisieren meiner bestehenden Angebote brauche.",
  },
];
